import React, { Component } from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { Redirect } from 'react-router-dom'

import { funcionContext } from '../../context/funcionContext'
import { Mensajes } from '../../components/Flujo/Mensajes'


export class LanHeader extends Component {
    displayName = LanHeader.name
    
    constructor(props) {
        super(props);
        this.state = {
            invalido: false,
            confirmado: false,
            confirmacion: [],
            loading: true,
            numeroGuia: props.numeroGuia,
            idModulo: props.idModulo,
            token: props.token,
            redirect: false,
            infoValida: false,
            vencido: false
        };
    }

    componentDidMount() {
        const values = this.state.numeroGuia;
        
        if (values != undefined) {
            fetch(window.env.API_DOMAIN_ADDR+'/api/Confirmacion/Consulta/' + values, {
                headers: {
                    'authorizedtoken': this.state.token,
                    'user': window.env.API_USER,
                    'refnumber': this.state.numeroGuia
                }
            })
            .then(response => {
                if (response.clone().status != 200) {
                    if (response.clone().status == 204) {//No data
                        this.setState({ loading: false });
                    } else {
                        this.setState({ invalido: true, loading: false });
                    }
                } else {
                    response.json().then(data => {
                        if (this.state.invalido == false) {
                            let vence = new Date(data.fechA_VENCIMIENTO);
                            let hoy = new Date(); //Fecha actual
                            console.log(vence);
                            console.log(hoy);
                            if (hoy >= vence) {//Pasaron las 48 horas
                                this.setState({ confirmacion: data, vencido: true, loading: false });
                            } else {
                                if (data.estadO_ACTUALIZACION_DATOS != 6) {
                                    this.setState({ confirmacion: data, infoValida: true, loading: false });
                                } else {
                                    this.setState({ confirmacion: data, confirmado: true, loading: false });
                                }
                            }
                        }
                    });
                }
            });
        }
    }
    
    static renderLanding(landingHeader, c) {
        return (
            <div>
            <form>
                <Grid fluid className="grid">
                    <Row>
                        <Col className="gridHeaderImg">
                                <img src="/media/images/Confirmaciones.png" />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="gridHeader">
                            <h2>Datos del ENVÍO</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={8} className="gridCol t gridH">
                            <label>
                                No. de guía: {landingHeader.numerO_GUIA}
                            </label>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={8} className="gridCol t">
                            <label style={{ width: "100%" }}>
                                    <span>{landingHeader.iD_DEVOLUCION_REMITENTE?'Remitente:':'Destinatario:'}</span>
                                    <input style={{ width: "75%" }} disabled type="text" name="n_guia" value={landingHeader.nombre} />
                            </label>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={8} sm={10} className="gridCol l">
                            <label style={{ width: "100%"}}>
                                <span>Entrega:</span>
                                <input className="gridColEntrega" style={{ width: "75%" }} disabled type="text" name="n_guia" value={landingHeader.direccion} />
                            </label>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={5} sm={8} className="gridCol l">
                                <label style={{ width: "100%" }}>
                                    <span className = "spanCiudad" style={{ visibility: "hidden" }}>Ciudad:</span>
                                    <input style={{ width: "100%" }} disabled type="text" name="n_guia" value={landingHeader.nombrE_CIUDAD} />
                            </label>
                        </Col>
                        <Col md={5} sm={8} className="gridCol">
                            <label>
                                <span>Contacto:</span>
                                    <input disabled type="text" name="n_guia" value={landingHeader.telefono} />
                            </label>
                        </Col>
                    </Row>
                </Grid>
                <hr/>
                </form>

                <funcionContext.Provider value={landingHeader.iD_FUNCION}>
                    <Mensajes numeroGuia={c.state.numeroGuia} idPais={c.state.confirmacion.iD_PAIS} idCiudad={c.state.confirmacion.iD_CIUDAD} idModulo={c.state.idModulo} idCliente={c.state.confirmacion.iD_CLIENTE_PS} token={c.state.token} fechaVencimiento={landingHeader.fechA_VENCIMIENTO} nombreConfirma={landingHeader.nombre} valorPagar={landingHeader.valor} telefonoConfirma={landingHeader.telefono} ciudadConfirma={landingHeader.nombrE_CIUDAD} direccionConfirma={landingHeader.direccion}></Mensajes>
                </funcionContext.Provider>

            </div>
        );
    }

    static renderNoInfo() {
        return (
            <div>La guía no existe o no tiene confirmación activa</div>
        );
    }

    static renderInvalido() {
        return (
            <div>No tiene acceso para ver esta página</div>    
        );
    }

    static renderConfirmado(landing,c) {
        return <Redirect to={{
            pathname: '/MensajeFinal',
            state: { numeroGuia: c.state.numeroGuia, rechazo: false, token: c.state.token, idModulo: c.state.idModulo, funcion: landing.iD_FUNCION, confirmado: true }
        }}
        />;
    }

    static renderVencido(landing, c) {
        console.log(landing.iD_FUNCION);
        return <Redirect to={{
            pathname: '/MensajeFinal',
            state: { numeroGuia: c.state.numeroGuia, rechazo: false, token: c.state.token, idModulo: c.state.idModulo, funcion: landing.iD_FUNCION, vencido: true }
        }}
        />;
    }

    render() {
        let content = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.state.vencido == true ? LanHeader.renderVencido(this.state.confirmacion, this) : (this.state.confirmado == true ? LanHeader.renderConfirmado(this.state.confirmacion, this) : (this.state.invalido ? LanHeader.renderInvalido() : this.state.infoValida ? LanHeader.renderLanding(this.state.confirmacion, this) : LanHeader.renderNoInfo()));

        return (
            <div>
                {content}
            </div>
        );
    }
}
